import Text from "common/Typography/Text";
import { typography } from "@shared/common/Themes/typography";

export const getCustomStrategyPreview = (
  target: number[],
  isMobile?: boolean
) => {
  const lastNonZeroIndex = target
    ?.slice()
    .reverse()
    .findIndex((percent) => percent !== 0);
  const targets = target?.slice(0, target.length - lastNonZeroIndex);
  const targetsLength = targets?.length;
  return (
    targets && (
      <Text
        type="secondary"
        style={{
          display: "flex",
          flexWrap: "wrap",
          fontSize: isMobile ? typography.fontSizes.S : typography.fontSizes.M,
          justifyContent: "flex-end",
        }}
      >
        {targets.map((percent, index) => {
          return (
            <span style={{ marginLeft: 5 }} key={index}>
              {`${index + 1} (${percent}%)${
                index !== targetsLength - 1 ? "," : ""
              }`}
            </span>
          );
        })}
      </Text>
    )
  );
};
